import React, { ReactNode } from 'react';
import styles from './style.module.scss';

interface IProps {
    className?: string;
    label?: string;
    icon?: boolean
    children?: ReactNode
}

const LineInfo: React.FC<IProps> = ({ className, label, icon, children }) => {
    return <div className={[styles.lineInfo, className].join(' ')} data-icon={icon}>
        <div className='text-comment'>{label}:</div>
        <div className='ml-[5px] font-w4'>{children}</div>
    </div>;
};

export default LineInfo;
